import { render } from "./DemoList.vue?vue&type=template&id=23808e6a&scoped=true&ts=true"
import script from "./DemoList.vue?vue&type=script&lang=ts"
export * from "./DemoList.vue?vue&type=script&lang=ts"

import "./DemoList.vue?vue&type=style&index=0&id=23808e6a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23808e6a"]])

export default __exports__